<template>
  <Card :bordered="false" class="customflow-container" dis-hover>
    <div slot="title">
      <slot name="title"></slot>
      <p class="title-item">{{ this.$t('common.this_month') }}</p>
    </div>
    <a href="#" slot="extra">
      <Button
        size="small"
        type="dashed"
        class="extra-btn"
        @click="goToProblem"
        v-if="hasPageAccess('PROBLEM_DATA_MANAGE')"
      >
        {{ $t('common.more') }}
        <Icon type="ios-arrow-forward" />
      </Button>
      <slot name="extra"></slot>
    </a>
    <div class="top-line">
      <p>
        <!-- <span class="title">{{ $t('common.store_score') }}</span
        ><Icon
          size="16"
          :title="$t('common.store_score_desc')"
          type="ios-information-circle-outline"
        /> -->
      </p>
      <Select
        v-model="sortWay"
        :transfer="false"
        style="width: 80px; height: 32px"
        @on-change="getData"
      >
        <Option :value="1">{{ $t('common.all') }}</Option>
        <Option :value="2">{{ $t('home.without_manual_create') }}</Option>
      </Select>
    </div>
    <Spin size="large" v-show="isLoading" fix></Spin>
    <div class="charts-body">
      <div id="todo-list-echarts"></div>
    </div>
  </Card>
</template>

<script>
import api from '../../../api/home/index';
import * as echarts from 'echarts';
import moment from 'moment';
import { privileageAccess } from '../../../mixins/privileage';
import { getLanguage } from 'wdz-common-components/src/common/js/ovoSystem';
export default {
  mixins: [privileageAccess],
  name: 'todo-list-card',
  data() {
    return {
      chartLegends: [],
      options: {},
      myChart: null,
      sortWay: 1,
      isLoading: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    myEchartsResize() {
      this.myChart && this.myChart.resize();
    },
    getData() {
      this.isLoading = true;
      api
        .getTodoList({ containsManual: this.sortWay })
        .then(res => {
          this.isLoading = false;
          this.formatChartData(res);
        })
        .catch(error => {
          console.error(`${this.$t('home.error_gettodolist')}：${error}`);
        });
    },
    formatChartData(data) {
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById('todo-list-echarts'), null, { renderer: 'svg' });
      const totalNum =
        data.notReformNum + data.notReviewNum + data.solveProblemNum;
      let option = {
        tooltip: {
          trigger: 'item',
          position: 'left',
        },
        color: ['#5789ff', '#f90', '#7ED321'],
        grid: [
          {
            right: '3%',
          },
        ],
        legend: {
          orient: 'vertical',
          x: 'left',
          y: 'center',
          left: '12%',
          top: '28%',
          itemHeight: 12, //图例的高度
          itemWidth: 12,
          itemGap: 20,
          icon: 'circle',
          textStyle: {
            rich: {
              n: {
                display: 'inline-block',
                width: 40,
                color: '#7F7F7F',
              },
              v: {
                display: 'inline-block',
                width: 40,
              },
            },
          },
          //图例-待整改，待复检，已完成
          data: [
            this.$t('home.notSolveProblemNum'),
            this.$t('home.notReviewNum'),
            this.$t('home.solveProblemNum'),
          ],
          formatter: function (name) {
            let index = 0;
            option.series[0].data.forEach((val, i) => {
              if (val.name === name) {
                index = i;
              }
            });
            if (getLanguage() == 'zh-CN' || getLanguage() == 'zh-TW') {
              return `{n|${name}} {v|${option.series[0].data[index].value}}`;
            } else {
              return `{n|${name}}                 {v|${option.series[0].data[index].value}}`;
            }
          },
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: ['65%', '75%'],
            center: ['68%', '50%'], //距离左右，上下距离的百分比
            avoidLabelOverlap: false,
            hoverOffset: 5,
            label: {
              show: true,
              position: 'center',
              formatter: `{b|${totalNum}}\n${this.$t('common.allProblem')}`,
              rich: {
                b: {
                  fontSize: 20,
                  fontWeight: 'bold',
                  color: '#333333',
                  lineHeight: '26',
                },
              },
            },
            data: [
              {
                value: data.notReformNum,
                name: this.$t('home.notSolveProblemNum'),
              },
              {
                value: data.notReviewNum,
                name: this.$t('home.notReviewNum'),
              },
              {
                value: data.solveProblemNum,
                name: this.$t('home.solveProblemNum'),
              },
            ],
          },
        ],
      };

      // let options = doughnutOption;
      // options.title.text = `${totalNum}\n${this.$t('common.allProblem')}`;
      // options.legend.formatter = function(name) {
      //   let index = 0;
      //   options.legend.data.forEach((val, i) => {
      //     if (val === name) {
      //       index = i;
      //     }
      //   });
      //   return `{n|${name}}{v|${seriesData[index].value}}`;
      // };

      // 绘制图表
      myChart.setOption(option);
      this.myChart = myChart;
    },
    goToProblem() {
      const params = {
        startTime: moment().startOf('month').format('YYYY-MM-DD'), 
        endTime: moment().endOf('month').format('YYYY-MM-DD'),
        status: '3, 4, 5', //待复检，已完成，待整改
        from: 'homepage'
      };
      const queryParams = Object.keys(params)
       .map(key => `${key}=${encodeURIComponent(params[key])}`)
       .join('&');
      
      this.$system.goRouter({
        router: {
          //路由跳转信息,必填
          // eslint-disable-next-line no-undef
          system: ccconstants.SYSTEM_NOS.Web_Boss, //系统编号，用于��识该功能模块现在做在哪个系统里面
          url: `/patrol-shop/index.html/problem/data-manage?${queryParams}`, //跳转路径，需要填写在相应系统里面的路由地址
        },
       });
    },
  },
};
</script>

<style scoped lang="scss" type="text/scss">
::v-deep {
  .ivu-card-head p {
    width: auto;
  }
}
.title-item {
  padding: 0 5px;
  height: 18px;
  background: #f0f0f0;
  border-radius: 3px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  font-size: 12px;
  color: #b2b2b2;
  letter-spacing: 0;
  line-height: 16px;
  text-align: center;
  margin-left: 6px;
}
.top-line {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative !important;
  .title {
    display: inline-block;
    margin-right: 5px;
    font-weight: 600;
    font-size: 16px;
    color: #333333;
  }
}

.customflow-container {
  .charts-body {
    @include wh100;
    #todo-list-echarts {
      width: 100%;
      height: 100%;
    }
  }
  .echart-container {
    @include wh100;
  }
}
</style>
